{
	"name": "@ngm-dev/cli",
	"description": "A CLI for ui.angular-material.dev",
	"version": "1.12.13",
	"homepage": "https://ui.angular-material.dev/docs/cli",
	"author": {
		"name": "Dharmen Shah",
		"url": "https://github.com/shhdharmen"
	},
	"bugs": {
		"url": "https://github.com/Angular-Material-Dev/community/issues"
	},
	"keywords": [
		"angular",
		"material",
		"ui",
		"components",
		"library",
		"framework",
		"angular-material",
		"angular-material-dev",
		"angular-material-ui",
		"angular-material-components",
		"angular-material-library",
		"angular-material-framework",
		"blocks",
		"blocks-angular-material",
		"blocks-angular-material-dev",
		"blocks-angular-material-ui",
		"blocks-angular-material-components",
		"blocks-angular-material-library",
		"blocks-angular-material-framework"
	],
	"type": "module",
	"exports": {
		".": {
			"types": "./dist/api/index.d.ts",
			"default": "./dist/api/index.js"
		}
	},
	"bin": "./dist/index.js",
	"main": "./dist/index.js",
	"files": [
		"./schemas/**/*",
		"dist/**/*"
	],
	"scripts": {
		"start": "tsup --silent && node ./dist/index.js",
		"build": "tsup",
		"format": "prettier . --write",
		"lint": "eslint --fix",
		"test": "vitest",
		"check:types": "tsc",
		"build:docs": "pnpm dlx tsx ./scripts/generate-docs.ts"
	},
	"devDependencies": {
		"@eslint/js": "^9.22.0",
		"@types/diff": "^7.0.1",
		"@types/glob": "^8.1.0",
		"@types/node": "^22.13.10",
		"@types/semver": "^7.5.8",
		"@types/validate-npm-package-name": "^4.0.2",
		"eslint": "^9.22.0",
		"globals": "^16.0.0",
		"tsup": "^8.4.0",
		"typescript": "^5.8.2",
		"typescript-eslint": "^8.26.0",
		"vitest": "^3.0.8"
	},
	"dependencies": {
		"@anthropic-ai/sdk": "^0.39.0",
		"@clack/prompts": "^0.10.0",
		"@modelcontextprotocol/sdk": "^1.9.0",
		"boxen": "^8.0.1",
		"chalk": "^5.4.1",
		"commander": "^13.1.0",
		"conf": "^13.1.0",
		"css-dependency": "^0.0.3",
		"diff": "^7.0.0",
		"dotenv": "^16.4.7",
		"escape-string-regexp": "^5.0.0",
		"estree-walker": "^3.0.3",
		"execa": "^9.5.2",
		"get-tsconfig": "^4.10.0",
		"glob": "^11.0.1",
		"ignore": "^7.0.3",
		"is-unicode-supported": "^2.1.0",
		"node-fetch": "^3.3.2",
		"octokit": "^4.1.2",
		"ollama": "^0.5.14",
		"openai": "^4.86.2",
		"oxc-parser": "^0.56.5",
		"package-manager-detector": "^1.0.0",
		"parse5": "^7.2.1",
		"pathe": "^2.0.3",
		"prettier": "^3.5.3",
		"semver": "^7.7.1",
		"sisteransi": "^1.0.5",
		"svelte": "^5.22.6",
		"valibot": "1.0.0-rc.3",
		"validate-npm-package-name": "^6.0.0",
		"vue": "^3.5.13",
		"zod": "^3.24.2"
	}
}
